<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "新建退款" : "编辑退款" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='500'
      :fullscreen='$isMobile'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="退款编号"
                  readonly
                  hide-details='auto'
                  outlined
                  :rules="required"
                  v-model="form.refundNumber">
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md='6'>
                <v-text-field label="退款金额" hide-details='auto' outlined :rules="maxMoney" v-model="form.money"></v-text-field>
              </v-col>
              <v-col cols="12" md='6'>
                <v-select
                  :items="refundTypeItems"
                  label="退款原因"
                  v-model="form.refundTypeId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md='6'>
                <v-select
                  :rules="number"
                  hide-details="auto"
                  outlined
                  :items="[ { text: '需要', value: 1}, {text: '不需要', value: 0}]"
                  label="是需要退还提成"
                  v-model="form.isBackMoney"
                ></v-select>
              </v-col>
              <v-col cols="12" md='6'>
                <v-select
                  :rules="number"
                  hide-details="auto"
                  outlined
                  :items="[ { text: '无居间费支出', value: 1}, {text: '已追回居间费', value: 2}, {text: '需追回居间费', value: 3}]"
                  label="居间费追回"
                  v-model="form.mediatorType"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field label="收款单位/人名称" hide-details='auto' outlined :rules="required" v-model="form.collectName"></v-text-field>
              </v-col>
            </v-row>

             <v-row>
              <v-col cols="12">
                <v-text-field label="银行账号" hide-details='auto' outlined :rules="required" v-model="form.bankAccount"></v-text-field>
              </v-col>
            </v-row>

             <v-row>
              <v-col cols="12">
                <v-text-field label="开户行" hide-details='auto' outlined :rules="required" v-model="form.bankType"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea rows='3' label="备注信息" :rules="required" outlined v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>


          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/contract/refund.js'
  import { getByPid } from '@/api/system/dictionary.js'
  import { serialNumber } from '@/utils/stringUtil.js'

  export default {
    name: 'RefundAdd',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
        })
      },
      surplusMoney: {
        type: Number,
        default: 0
      }
    },
    components: {
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        maxMoney: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && value <= this.surplusMoney) || `金额必填且不得超过${this.surplusMoney}`,
        ],
        number: [
          value => /^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) || '必须输入数字',
        ],
        param: {},
        form: {
          id: '',
          contractId: '',
          customerId: '',
          collectName: '',
          bankAccount: '',
          refundNumber: '',
          bankType: '',
          money: '',
          refundTypeId: '',
          remark: '',
          isBackMoney: '',
          mediatorType: ''
        },
        refundTypeItems: []
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      refundNumber () {
        this.form.refundNumber = serialNumber('YD.')
      },
      dialogChange (val) {
        this.item.show = val
        this.form.contractId = this.item.data.id
        this.form.customerId = this.item.data.customerId
        this.form.collectName = this.item.data.customer.name
        this.form.money = this.surplusMoney
        this.refundNumber()
        if (!val) {
          this.$refs.form.reset()
        } else {
          this.$refs.form.resetValidation()
        }
      },
      getType () {
        getByPid(this.$constants.contractRefundTypePid).then(res => {
          if (res.status === 200) {
            this.refundTypeItems = res.data
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    },
    created () {
      this.getType()
    }
  }
</script>

<style>
</style>
